<!--
 * @Author: LiuMeiYu
 * @Date: 2023-01-10 14:04:02
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-02-06 22:24:53
 * @FilePath: \nivara\src\layout\layoutView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="nivara-layout">
    <el-container>
      <el-header><Header></Header></el-header>
      <el-main><router-view></router-view></el-main>
      <el-footer><Footer></Footer></el-footer>
    </el-container>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import Header from "../components/HeaderView.vue";
import Footer from "../components/FooterView.vue";
export default defineComponent({
  name: "layoutView",
  components: {
    Header,
    Footer,
  },
  props: {},
  emits: [],
  setup() {
    return {};
  },
})
</script>
<style lang="less" scoped>
.nivara-layout {
  width: 100%;
  .el-header {
    width: 100%;
    height: auto;
    padding: 0;
  }
  .el-main {
    padding: 0;
  }
  .el-footer {
    padding: 0;
  }
}
</style>